import { Routes } from '@angular/router';
import { AuthGuard } from '@i7/shared';

export const cmlRoutes: Routes = [
  {
    path: 'atendimento-pedido',
    loadChildren: () =>
      import(
        '../pages/cml/atendimento-pedido/atendimento-pedido.module'
      ).then((module) => module.AtendimentoPedidoModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'cadastro-generico',
    loadChildren: () =>
      import(
        '../pages/cad/cadastro-generico/cadastro-generico.module'
      ).then((module) => module.CadastroGenericoModule),
    canActivate: [AuthGuard],
  },
  {
    path: "bloqueio-comercial",
    loadChildren: () =>
      import("../pages/cml/bloqueios/bloqueios.module").then(
        (module) => module.BloqueiosModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "representante",
    loadChildren: () =>
      import('../pages/cml/representante/representante.module').then(
        (module) => module.RepresentanteModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'tabela-preco',
    loadChildren: () =>
      import('../pages/cml/tabela-preco/tabela-preco.module').then(
        (module) => module.TabelaPrecoModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'lista-preco',
    loadChildren: () =>
      import('../pages/cml/lista-preco/lista-preco.module').then(
        (module) => module.ListaPrecoModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'pedido-venda',
    loadChildren: () =>
      import('../pages/cml/pedido-venda/pedido-venda.module').then(
        (module) => module.PedidoVendaModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'carga',
    loadChildren: () =>
      import('../pages/cml/carga/carga.module').then(
        (module) => module.CargaModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'faturar-carga',
    loadChildren: () =>
      import('../pages/cml/faturar-carga/faturar-carga.module').then(
        (module) => module.FaturarCargaModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'saldo',
    loadChildren: () =>
      import('../pages/bas/saldo/saldo.module').then(
        (module) => module.SaldoModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'saldo-comissao',
    loadChildren: () =>
      import('../pages/bas/saldo/saldo.module').then(
        (module) => module.SaldoModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'saldo-parceiro',
    loadChildren: () =>
      import('../pages/bas/saldo/saldo.module').then(
        (module) => module.SaldoModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'saldo-parceiro-atendimento',
    loadChildren: () =>
      import('../pages/bas/saldo/saldo.module').then(
        (module) => module.SaldoModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'indice',
    loadChildren: () =>
      import('../pages/bas/indice/indice.module').then(
        (module) => module.IndiceModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'configurador-comissao',
    loadChildren: () =>
      import('../pages/cml/configurador-comissao/configurador-comissao.module').then(
        (module) => module.ConfiguradorComissaoModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'configurador-meta',
    loadChildren: () =>
      import('../pages/cml/configurador-meta/configurador-meta.module').then(
        (module) => module.ConfiguradorMetaModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'manutencao-meta',
    loadChildren: () =>
      import('../pages/cml/manutencao-meta/manutencao-meta.module').then(
        (module) => module.ManutencaoMetaModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'comissao-pendente',
    loadChildren: () =>
      import('../pages/cml/comissao-pendente/comissao-pendente.module').then(
        (module) => module.ComissaoPendenteModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'comissao-provisionada',
    loadChildren: () =>
      import('../pages/cml/comissao-provisionada/comissao-provisionada.module').then(
        (module) => module.ComissaoProvisionadaModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'funil-vendas',
    loadComponent: () =>
      import('../pages/bas/kanban/board/kanban-board.component').then(
        (component) => component.KanbanBoardComponent,
      ),
    canActivate: [AuthGuard],
  }
];
